import { GameSettleInfo, SprintResult } from '#/chess';

/**
 * 初始局面
 */
export const INIT_FEN = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1';

/**
 * 空局面
 */
export const EMPTY_FEN = '8/8/8/8/8/8/8/8';

export const LAST_TAG_COMMENT = '%tag Last';

/**
 * 对手名称
 */
export const OPPONENT_NAME = 'duishou';

/**
 * 随机颜色
 */
export const RANDOM_COLOR = 'randomColor';

/**
 * 人机名称
 */
export const ROBOT_NAME = 'ChessBot';

/**
 * 对弈重连完成标志
 */
export const GAME_RECONNECT_FINISH = 'GAME_RECONNECT_FINISH';

/**
 * 冲刺练习连击配置
 */
export const SPRINT_COMBO_CONFIG: Array<{ time: number; needCombo: number }> = [
    {
        time: 3,
        needCombo: 5,
    },
    {
        time: 5,
        needCombo: 7,
    },
    {
        time: 7,
        needCombo: 8,
    },
    {
        time: 10,
        needCombo: 10,
    },
];

/**
 * 好友习题 PK 连击配置
 */
export const SPRINT_PK_COMBO_CONFIG: Array<{ time: number; needCombo: number }> = [
    {
        time: 1,
        needCombo: 5,
    },
    {
        time: 2,
        needCombo: 7,
    },
    {
        time: 3,
        needCombo: 8,
    },
    {
        time: 4,
        needCombo: 10,
    },
];

export const INIT_SPRINT_RESULT: SprintResult = {
    successSubjectNum: 0,
    successForwardNum: 0,
    successRate: 0,
    time: 0,
    maxContinuitySuccessNum: 0,
    errorForwardNum: 0,
    forwardNum: 0,
    forwardTime: 0,
    goingPoint: 0,
};

export const INIT_SETTLE_CONFIG: GameSettleInfo = {
    prev: 0,
    diff: 0,
    late: 0,
};
